import { FeedBackForm, Modal } from '@/components'
import { StyledButton } from '@/components/styles'
import { useTranslation } from "react-i18next";

const Trigger = props => {
  const { t } = useTranslation("global");
  return <StyledButton size="mid" {...props}>{t('leaveFeedback')}</StyledButton>
}

export default function FeedBack({ render: TriggerView = Trigger, id }) {
  return (
    <Modal render={TriggerView} view="appointment">
      <FeedBackForm id={id}/>
    </Modal>
  )
}
